import React from 'react';

import { PlacementId } from '@schibsted-nmp/advertising-shared';

interface AdvertisingAfsWebComponentProps {
  placementId: PlacementId;
}

export const AdvertisingAfsWebComponent = ({
  placementId
}: AdvertisingAfsWebComponentProps) => (
  <advt-component placementId={placementId} />
);
